<template>
    <div class="row  go-form-row" v-show="inputItem.display == null ? true : inputItem.display">
        <!--        常规label-->
        <go-label :labelWidth="labelWidth" :btnLabel="true" :labelAlign="labelAlign" :item="inputItem"></go-label>
        <div  :class="'go-content ' + getInputWid()" :style="getInputWidStyle()">
            <div class="go-content-body">
                 <div class="go-btn"  @click="clickBtn"  :style="_inputStyle">
                     <slot></slot>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoLabel from "./commponents/go-label";
    import formMixin from "../../mixins/formMixins";

    export default {
        name: "go-btn",
        mixins: [formMixin],
        data() {
            return {
                clearIconRight:5,
                hoverFlag: false,
            };
        },
        props: {
            type: {
                type: String,
                default: ''
            },
            btnStyle: {
                type: Object,
                default: null
            }
        },
        computed: {
            _inputStyle() {
                if (this.btnStyle) {
                    return {...this.btnStyle};
                } else {
                    return {};
                }
            },
        },
        methods: {
            clickBtn(){
                this.$emit('click');
            }
        },
        mounted() {

        },
        watch: {

        },
        components: {
            GoLabel
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-input-btn.vue